module.exports = __webpack_public_path__ + "img/resize-icon-ml.02a74b72.svg";